import React from "react";
import Newest from "../../../../assets/icons/Newest.svg";
import Popular from "../../../../assets/icons/Popular.svg";
import Follow from "../../../../assets/icons/Follow.svg";

const SideBar = () => {
  return (
    <div
      data-dark="On"
      className="w-full sm:w-52 p-2.5 bg-white rounded-2xl flex flex-col justify-start items-start gap-2.5"
    >
      <div className="flex flex-col justify-start items-start gap-2.5">
        <TeaserCard
          icon={Newest}
          label="Newest and Recent"
          subtext="Find the latest update"
        />
        <TeaserCard
          icon={Popular}
          label="Popular of the day"
          subtext="Shots featured today by curators"
        />
        <TeaserCard
          icon={Follow}
          label="Following"
          subtext="Explore from your favorite person"
        />
      </div>
    </div>
  );
};

const TeaserCard = ({ label, subtext, icon }) => (
  <div className="w-full px-[5px] py-1.5 bg-gradient-to-r from-zinc-100 to-zinc-200 rounded-md relative pointer-events-none select-none animate-pulse">
    <div className="flex items-center gap-1.5">
      {/* SVG icon with black background */}
      <div className="p-1 bg-black rounded-md">
        <div className="w-5 h-5 flex items-center justify-center">
          <img src={icon} alt={`${label} icon`} className="w-4 h-4 object-contain" />
        </div>
      </div>

      {/* Label and subtext with 'Coming Soon' tag */}
      <div className="flex flex-col gap-0.5">
        <div className="text-gray-500 text-xs font-semibold leading-none flex items-center gap-1">
          {label}
        </div>
        <div className="text-neutral-400 text-[9px] leading-none">{subtext}</div>
      </div>
    </div>
  </div>
);

export default SideBar;
